import { HOME_ID, AI_CREATE } from "template-store/constants/categories";
import { TEMPLATE_CENTER_AI_CREATE_LINK } from "constants/links";
const ROOT_DIR = "templates";
export const getSolutionPageLink = (solutionId, solutionEnglishName)=>{
    const normalizedName = solutionEnglishName.replace(/ /g, "-").toLowerCase(); // replaceAll not supported in node 10
    return `/${ROOT_DIR}/template/${solutionId}/${normalizedName}`;
};
export const getSolutionCategoryPageLink = (categoryId)=>{
    if (categoryId === HOME_ID) return getSolutionsHomeLink();
    if (categoryId === AI_CREATE) return TEMPLATE_CENTER_AI_CREATE_LINK;
    return `/${ROOT_DIR}/category/${categoryId}`;
};
export const getSolutionSearchLink = (searchTerm)=>{
    return `/${ROOT_DIR}/search?term=${searchTerm}`;
};
export const getSolutionsHomeLink = ()=>{
    return `/${ROOT_DIR}`;
};
